/**
 * AIチャットで使用するドキュメントタイプの型定義
 */
export type AIChatDocumentType =
  | "system-proposal"
  | "functional-requirements"
  | "non-functional-requirements"
  | "plugin-proposal"
  | "app-design"
  | "field-design"
  | "customize-specification";

/**
 * AIチャットでの編集が無効化されるドキュメントタイプ一覧
 * 新しいドキュメントタイプを編集不可にする場合は、この配列に追加するだけでOK
 */
export const NON_EDITABLE_DOCUMENT_TYPES: readonly AIChatDocumentType[] = [
  "plugin-proposal",
  "customize-specification",
  "field-design",
] as const;

/**
 * 指定されたドキュメントタイプが編集不可かどうかを判定
 */
export const isNonEditableDocumentType = (documentType: string): boolean =>
  (NON_EDITABLE_DOCUMENT_TYPES as readonly string[]).includes(documentType);
